
import { useId } from 'react';
import styles from './MyAccount.module.css';

export interface ToggleProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label': string;
}

export function Toggle({ checked, onChange, disabled = false, 'aria-label': ariaLabel }: ToggleProps) {
  const id = useId();
  return (
    <span className={styles.switchWrap}>
      <input
        id={id}
        type="checkbox"
        role="switch"
        className={styles.switchInput}
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <span className={styles.switch} aria-hidden="true" />
    </span>
  );
}
